
export const SPIELER_FIELD_SETTINGS = {
    lvNr: {         excel: 'LV Nummer', app: 'LVNr', childOf: '',
                    type: 'integer'
    },
    vereinsNr: {    excel: 'Vereins-nummer', app: 'Vereins Nr.', childOf: '',
                    type: 'integer'
    },
    lvId: {         excel: 'LV Nummer', app: 'LVNr', childOf: 'local',
                    type: 'integer'
    },
    vereinId: {    excel: 'Vereins-nummer', app: 'Vereins Nr.', childOf: 'local',
                    type: 'integer'
    },
    passNr: {       excel: 'Pass Nummer', app: 'Passnr.', childOf: '',
                    type: 'integer'
    },
    leihPassNr: {       excel: 'Pass Nummer', app: 'Leih-Passnr.', childOf: 'local',
                    type: 'integer'
    },
    nachname: {     excel: 'Familienname', app: 'Nachname', childOf: '',
                    type: 'string',
                    cols: 4
    },
    vorname: {      excel: 'Vorname', app: 'Vorname', childOf: '',
                    type: 'string',
                    cols: 3
    },
    titel: {        excel: 'Titel', app: 'Titel', childOf: '',
                    type: 'string',
                    cols: 2,
                    optional: true,
    },
    geschlecht: {   excel: 'Geschlecht', app: 'Geschlecht', childOf: '',
                    type: 'select',
                    cols: 3,
                    values: [{text: 'männlich', value: 'm'},{text: 'weiblich', value: 'f'}]
    },
    ak: {   excel: 'ak', app: 'Altersklasse', childOf: '',
        type: 'string',
        cols: 2,
    },
// private start
    strasse: {      excel: 'Strasse', app: 'Strasse', childOf: 'private',
                    type: 'string',
                    cols: 7,
    },
    plz: {          excel: 'PLZ', app: 'PLZ', childOf: 'private',
                    type: 'integer',
                    cols: 2,
    },
    ort: {          excel: 'Ort', app: 'Ort', childOf: 'private',
                    type: 'string',
                    cols: 3,
    },
    telefon: {      excel: 'Telefon', app: 'Telefon Festnetz', childOf: 'private',
                    type: 'string',
                    cols: 4,
                    optional: true,
    },
    mobilTelefon: { excel: 'Mobil Tel.:', app: 'Telefon mobil', childOf: 'private',
                    type: 'string',
                    cols: 4,
                    optional: true,
    },
    eMail: { excel: 'E-Mail', app: 'E-mail', childOf: 'private',
                    type: 'string',
                    cols: 4,
                    optional: true,
    },
    geburtsdatum: { excel: 'Geburtsdatum', app: 'Geburtsdatum', childOf: 'private',
                    type: 'date',
                    cols: 4,
                    notInFuture: true,
    },
    geburtsort: {   excel: 'Geburtsort', app: 'Geburtsort', childOf: 'private',
                    type: 'string',
                    cols: 4,
                    optional: true,
    },
    nationalitaet: {excel: 'Nationalität', app: 'Nationalität', childOf: 'private',
                    type: 'select',
                    cols: 4,
                    values: ['AUT', 'BEL', 'BIH', 'BUL', 'CRO', 'CZE', 'ESP', 'FRA', 'GBR', 'GER',
                             'HUN', 'IRN', 'ITA', 'JPN', 'KEN', 'KOR', 'LIE', 'MKD', 'MNE', 'NED', 'PHI',
                             'POL', 'ROU', 'RUS', 'SLO', 'SRB', 'SUI', 'SVK',
                             'SYR', 'THA', 'TUR', 'UKR', 'USA', 'andere' ]
    },
// private end
    anmeldeTag: {   excel: 'Anmeldetag', app: 'Anmeldetag', childOf: 'dates',
                    type: 'date',
                    cols: 4
    },
    attest: {       excel: 'Ärztliches Attest', app: 'Ärztliches Attest', childOf: '',
                    type: 'date',
                    cols: 4,
                    optional: true,
                    errorMsg: '',
                    notInFuture: true,
    },
    dsv: {          excel: 'DSV', app: 'DSV', childOf: '',
                    type: 'date',
                    cols: 4,
                    notInFuture: true,
    },
    ade: {          excel: 'ADE', app: 'ADE', childOf: '',
                    type: 'date',
                    cols: 4,
                    optional: true,
                    errorMsg: '',
                    notInFuture: true,
    },
    handicap: {     excel: 'Behinderten Status', app: 'Behinderten Status', childOf: '',
                    cols: 4,
                    optional: true,
                    type: 'string'
    },
    bemerkung: {    excel: 'Bemerkung', app: 'Bemerkung', childOf: '',
                    type: 'string',
                    cols: 8,
                    optional: true,
    },
    nbcId: {
        excel: 'nbcId', app: 'NBC-Id', childOf: '',
        type: '',
        cols: 4,
        optional: true,
    },
    status: {       excel: 'Status', app: 'Status', childOf: '',
                    type: 'string',
                    cols: 12,
                    optional: false,
    },
    statusDisplay: {excel: 'Status', app: 'Status', childOf: 'local',
                    type: 'string',
                    cols: 12,
                    optional: false,
    },
    letzteAenderung: {excel: 'geändert', app: 'geändert vor', childOf: '',
                    type: 'integer',
                    cols: 12,
                    optional: false,
    },
    lastSportTag: {excel: 'Pass gültig bis', app: 'Pass gültig bis', type: 'date', childOf: 'dates'},
}